<div class="offerCard offer-card" id="offerCard" [ngClass]="showOnOfferPage ? 'h-100 pb-5' : ''">
  <mat-card appearance="outlined" class="pointer offer-card__container">
    <div class="heading h4 text-center offer-card__header" [innerHTML]="externalOffer?.header">
    </div>
    <div class="offerImage offer-card__image">
      @if (externalOffer?.image && externalOffer?.image?.src) {
        <img mat-card-image class="offer-card__img"
             [ngSrc]="externalOffer?.image?.src"
             [width]="imageService.width"
             [height]="imageService.height"
             [alt]="externalOffer?.image?.altText">
      }
    </div>
    <div class="offer-card__content">
      <div class="text-center offer-card__price">
        <div class="h5">{{ externalOffer.price | currency }}</div>
      </div>
      <ng-template #pricetext>
        <div class="text-center offerPrice offer-card__additional-data">
          <div class="h5" [innerHTML]="externalOffer?.additionalData"></div>
        </div>
      </ng-template>

      <div class="footer offer-card__footer">
        <div class="text-center offerButton offer-card__button">
          <button mat-raised-button color="primary"
                  (click)="navigationService.navigateExtern(externalOffer.externalURL, true)">
            <!-- Benutzung von [innerHtml] führt zu Hydration-Error -->
            {{ translationService.getTranslation('button_order') }}
          </button>
        </div>
      </div>
    </div>
  </mat-card>
</div>
